// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mps__back {
  background: transparent;
  border: 0;
  color: var(--tpl-accent);
  padding: 0;
  margin-bottom: 10px;
  font: inherit;
  font-weight: 650;
  cursor: pointer;
}

.mps__label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 0.82rem;
  color: var(--tpl-muted);
  margin: 16px 0;
}

.mps__label input {
  background: var(--tpl-surface);
  border: 1px solid var(--tpl-border);
  color: var(--tpl-text);
  border-radius: 10px;
  padding: 10px 12px;
  font: inherit;
}

.mps__label input::placeholder {
  color: color-mix(in srgb, var(--tpl-muted) 80%, transparent);
}

.mps__label input:focus {
  outline: 2px solid color-mix(in srgb, var(--tpl-primary) 45%, transparent);
  outline-offset: 1px;
}

.mps-q {
  margin: 12px 0;
  opacity: 0.55;
  color: var(--tpl-text);
}

.mps-q.is-now,
.mps-q.is-done {
  opacity: 1;
}

.mps-q p {
  margin: 0 0 8px;
  font-weight: 700;
  color: var(--tpl-text);
}

.mps-q__opts,
.mps__ctx {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.mps-q__opts button,
.mps__ctx button {
  background: var(--tpl-surface-2);
  color: var(--tpl-text);
  border: 1px solid var(--tpl-border);
  border-radius: 999px;
  padding: 7px 12px;
  font: inherit;
  font-weight: 650;
  cursor: pointer;
}

.mps-q__opts button:disabled,
.mps__ctx button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.mps-q__opts button.is-on,
.mps__ctx button.is-on {
  background: var(--tpl-primary);
  color: #fff;
  border-color: var(--tpl-primary-soft);
}

.mps__ctx {
  margin: 18px 0 8px;
}

.mps-plan {
  margin-top: 22px;
  background: var(--tpl-surface);
  border-radius: 16px;
  padding: 16px;
  border: 1px solid var(--tpl-border);
  color: var(--tpl-text);
}

.mps-plan h2 {
  margin-top: 0;
  color: var(--tpl-text);
}

.mps-plan p {
  margin: 0.45rem 0 0;
  color: var(--tpl-muted);
  line-height: 1.45;
}
`, "",{"version":3,"sources":["webpack://./src/pages/tactical/MatchPrepScout.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,0EAA0E;EAC1E,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,gCAAgC;EAChC,sBAAsB;EACtB,mCAAmC;EACnC,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,8BAA8B;EAC9B,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB","sourcesContent":[".mps__back {\n  background: transparent;\n  border: 0;\n  color: var(--tpl-accent);\n  padding: 0;\n  margin-bottom: 10px;\n  font: inherit;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.mps__label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 0.82rem;\n  color: var(--tpl-muted);\n  margin: 16px 0;\n}\n\n.mps__label input {\n  background: var(--tpl-surface);\n  border: 1px solid var(--tpl-border);\n  color: var(--tpl-text);\n  border-radius: 10px;\n  padding: 10px 12px;\n  font: inherit;\n}\n\n.mps__label input::placeholder {\n  color: color-mix(in srgb, var(--tpl-muted) 80%, transparent);\n}\n\n.mps__label input:focus {\n  outline: 2px solid color-mix(in srgb, var(--tpl-primary) 45%, transparent);\n  outline-offset: 1px;\n}\n\n.mps-q {\n  margin: 12px 0;\n  opacity: 0.55;\n  color: var(--tpl-text);\n}\n\n.mps-q.is-now,\n.mps-q.is-done {\n  opacity: 1;\n}\n\n.mps-q p {\n  margin: 0 0 8px;\n  font-weight: 700;\n  color: var(--tpl-text);\n}\n\n.mps-q__opts,\n.mps__ctx {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.mps-q__opts button,\n.mps__ctx button {\n  background: var(--tpl-surface-2);\n  color: var(--tpl-text);\n  border: 1px solid var(--tpl-border);\n  border-radius: 999px;\n  padding: 7px 12px;\n  font: inherit;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.mps-q__opts button:disabled,\n.mps__ctx button:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.mps-q__opts button.is-on,\n.mps__ctx button.is-on {\n  background: var(--tpl-primary);\n  color: #fff;\n  border-color: var(--tpl-primary-soft);\n}\n\n.mps__ctx {\n  margin: 18px 0 8px;\n}\n\n.mps-plan {\n  margin-top: 22px;\n  background: var(--tpl-surface);\n  border-radius: 16px;\n  padding: 16px;\n  border: 1px solid var(--tpl-border);\n  color: var(--tpl-text);\n}\n\n.mps-plan h2 {\n  margin-top: 0;\n  color: var(--tpl-text);\n}\n\n.mps-plan p {\n  margin: 0.45rem 0 0;\n  color: var(--tpl-muted);\n  line-height: 1.45;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
